// extracted by mini-css-extract-plugin
export default {"root":"RangeSlider_root__ysojt","activeHandle":"RangeSlider_activeHandle__fomVM"};